import React, { useEffect } from "react"
import {
  CardBody,
  CardHeader,
  CardHeaderTitle
} from "../../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../../component/atoms/RowModule/RowModule.jsx"
import { DetailText, RowText } from "../../../../../../component/index.jsx"
import { useDispatch, useSelector } from "react-redux"
import {
  fetchDistrictByRegencyId,
  fetchRegencyByProvinceId,
  fetchSubDistrictByDistrictId,
  getListRegionalAll
} from "../../../../../../redux/actions/MasterDataAction.jsx"
import { toStringDate } from "../../../../../helpers/DateHelper.js"
import { useTranslation } from "react-i18next"
import { GENDER_TYPE } from "../../../../../../constants/StringConstant.js"

export const DetailInputFarmer = ({ formData, editStep }) => {
  const { MasterData, Mitralist } = useSelector((state) => state)
  const {t} = useTranslation()
  const mitraName = Mitralist?.data?.filter((mitra) => mitra.id_mitra === formData?.mitraId)[0].name
  const bankName =
    formData?.farmerBankId === undefined
      ? ""
      : MasterData.bankList.filter((bank) => bank.id === formData?.farmerBankId)[0].name
  const regionalList = MasterData?.listRegionalAll ?? []
  const regional = regionalList?.find((e) => e?.id === formData?.regionalId)?.name ?? "-"
  const provinces = MasterData?.provinceList ?? []
  const province = provinces?.find((e) => e?.id === formData?.farmerProvince)?.name ?? "-"
  const regencies = MasterData?.regencyList ?? []
  const regency = regencies?.find((e) => e?.id === formData?.farmerRegency)?.name ?? "-"
  const districts = MasterData?.districtList ?? []
  const district = districts?.find((e) => e?.id === formData?.farmerDistrict)?.name ?? "-"
  const subDistricts = MasterData?.subDistrictList ?? []
  const subDistrict = subDistricts?.find((e) => e?.id === formData?.farmerSubDistrict)?.name ?? "-"

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchRegencyByProvinceId(formData?.farmerProvince))
    dispatch(fetchDistrictByRegencyId(formData?.farmerRegency))
    dispatch(fetchSubDistrictByDistrictId(formData?.farmerDistrict))
    dispatch(getListRegionalAll())
  }, [formData])

  return (
    <>
      <CardBody>
        <CardHeaderTitle>{`REVIEW ${t("card_title_farmer_data")}`.toUpperCase()}</CardHeaderTitle>
        <div className={"d-flex justify-content-between align-items-center pb-8 pt-16"}>
          <h4>{t("card_title_farmer_data")}</h4>

          <a
            className={"link"}
            onClick={() => {
              editStep(0)
            }}>
            EDIT
          </a>
        </div>

        <RowModule customColumnCss={"col-md-6"}>
          <RowModule customColumnCss={"col-md-12 mb-2"}>
            <RowText label="Regional" value={regional} />
          </RowModule>
          <RowModule customColumnCss={"col-md-12 mb-2"}>
            <RowText label={t("label_phone_number")} value={formData?.phoneNumber} />
          </RowModule>
          <RowModule customColumnCss={"col-md-12 mb-2"}>
            <RowText label={t("label_mitra_name")} value={mitraName} />
          </RowModule>
          <RowText
            label={t("label_gender")}
            value={
              formData?.gender === GENDER_TYPE.LAKI_LAKI.replace("-", "_")
                ? t("label_men")
                : formData?.gender === GENDER_TYPE.PEREMPUAN
                ? t("label_woman")
                : "-"
            }
          />
          <RowModule customColumnCss={"col-md-12 mb-2"}>
            <RowText label={t("label_farmer_name")} value={formData?.farmerName} />
          </RowModule>
          <RowModule customColumnCss={"col-md-12 mb-2"}>
            <RowText
              label={t("label_farmer_domicile_address")}
              value={`${formData?.farmerAddress}, ${subDistrict} , ${district}, ${regency}, ${province}  `}
            />
          </RowModule>
          <RowModule customColumnCss={"col-md-12 mb-2"}>
            <RowText label={t("label_date_of_birth")} value={toStringDate(formData?.dob)} />
          </RowModule>
        </RowModule>
        <CardHeader />
        <div className={"pt-10"}>
          <div className={"d-flex justify-content-between align-items-center py-8"}>
            <h4>{t("card_title_ktp_selfie")}</h4>

            <a
              className={"link"}
              onClick={() => {
                editStep(1)
              }}>
              EDIT
            </a>
          </div>
          <RowText label={t("label_ktp_number")} value={formData?.nomorKtp} />
          <DetailText type="image-dashed" value={formData?.fotoKtp} />
          <DetailText type="image-dashed" value={formData?.swafoto} />
        </div>

        <CardHeader />
        <div className={"pt-10"}>
          <div className={"d-flex justify-content-between align-items-center py-8"}>
            <h4>{t("label_bank_account")}</h4>

            <a
              className={"link"}
              onClick={() => {
                editStep(2)
              }}>
              EDIT
            </a>
          </div>
          <RowText label={t("label_bank_name")} value={bankName} />
          <RowText label={t("label_account_number")} value={formData?.farmerBankAccountNumber} />
          <RowText label={t("label_account_name")} value={formData?.farmerBankAccountName} />
          <CardHeader />
        </div>
      </CardBody>
    </>
  )
}